import projectStatuses from '~/lookups/project-statuses';
import React from 'react';
import styled from 'styled-components';
import ProjectPopover from '../../resources/allocations/components/ProjectPopover';
import { Assignment, Info, Label } from '../../resources/allocations/components/schedule/sidebar';
import {
  Action,
  Actions,
  Box,
  Content,
  Group as GroupContainer,
} from '../../resources/allocations/components/schedule/sidebar/SidebarStyles';
import SidebarMenu from '../../resources/allocations/components/schedule/sidebar/SidebarMenu';
import { useApi, useWorkspace } from '~/contexts';

const GroupActions = styled(Actions)`
  flex-direction: row;
`;

const GroupAction = styled(Action)`
  width: 1rem;
  margin-left: 0.5rem;
`;

export default function Group({ row, groups, onAssignAllocatedMembers, onShiftAllocations }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const group = groups[row.id];

  if (!group) return null;

  return (
    <GroupContainer
      key={row.id}
      style={row.meta.style}
      data-testid={`row_${row.id}`}
      data-testid-lanes={row.meta.lanes}
      state={group.state}>
      <Box>
        <Content>
          <Assignment tentative={row.project?.statusId === projectStatuses.tentative.id}>
            <Info>
              <Label>
                <ProjectPopover projectId={row.project.id}>{row.project.name}</ProjectPopover>
              </Label>
            </Info>
          </Assignment>
        </Content>

        <GroupActions>
          <GroupAction>
            <SidebarMenu>
              {({ setIsOpen }) => {
                const handleAssignAllocatedMembers = async () => {
                  setIsOpen(false);
                  await onAssignAllocatedMembers(row.project.id);
                };

                const handleShiftAllocations = async () => {
                  setIsOpen(false);
                  await onShiftAllocations(row.project);
                };

                return (
                  <>
                    <SidebarMenu.Item disabled={!onAssignAllocatedMembers} onClick={handleAssignAllocatedMembers}>
                      Assign Allocated Members to Project
                    </SidebarMenu.Item>
                    <SidebarMenu.Item
                      disabled={!onShiftAllocations}
                      onClick={handleShiftAllocations}
                      onMount={async (setState) => {
                        setState((state) => ({ ...state, disabled: true }));

                        try {
                          const { data: hasAllocations } = await api.www
                            .workspaces(workspace.id)
                            .allocations()
                            .projectSchedule.hasAllocations(row.project.id);

                          setState((state) => ({
                            ...state,
                            disabled: !hasAllocations,
                          }));
                        } catch {
                          // Do nothing
                        }
                      }}>
                      Shift All Allocations
                    </SidebarMenu.Item>
                  </>
                );
              }}
            </SidebarMenu>
          </GroupAction>
        </GroupActions>
      </Box>
    </GroupContainer>
  );
}
